import { LoginResponse, UserDto } from 'shared/api/__generated__';

export function getRedirectByUserRole(user: LoginResponse | UserDto | null) {
  // Если админ ЕРП - на список медорганизаций
  if (user?.role?.key === 'admin.erp') return '/manage/medical_orgs';

  // Если админ медорганизации - на страницу его медорганизации
  if (user?.role?.key === 'admin.mo' && user.medorg?.id)
    return `/manage/medical_orgs/${user.medorg.id}`;

  // Иначе, как обычно
  return '/';
}
